import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree,} from '@angular/router';
import {ConfigService} from "../../config";
import {Product} from "../../models/product";
import {AppStateService} from "../../state/app-state.service";

export const ProductGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {

  const PRODUCT_KEY = 'product';
  const config = inject(ConfigService);
  const appState = inject(AppStateService);
  const router = inject(Router);

  const product = route.data[PRODUCT_KEY] as Product | undefined;

  const getDefaultRedirection = (): UrlTree | boolean => {
    let redirection;

    if (config.getDiagnosis()?.enable) {
      redirection = '/diagnosis';
    } else if (config.getTyreScanner()?.enable) {
      redirection = '/scanner';
    } else if (config.getWebReport().reportAccessStrategies.length > 0) {
      redirection = '/report';
    } else if (config.getAppointment().enable) {
      redirection = '/appointment';
    }
    return redirection ? router.createUrlTree([redirection]) : false;
  }

  if (!product || product === Product.UNKNOWN) {
    console.warn('[ProductGuard] Missing or invalid product on route', route.routeConfig?.path);
    return getDefaultRedirection();
  }

  // Redirect depending on app configuration.
  let isAllowed = false;
  switch (product) {
    case Product.DIAGNOSIS:
      isAllowed = !!config.getDiagnosis()?.enable;
      break;
    case Product.SCANNER:
      isAllowed = !!config.getTyreScanner()?.enable;
      break;
    case Product.REPORT:
      isAllowed = config.getWebReport()?.reportAccessStrategies.length > 0;
      break;
    case Product.APPOINTMENT:
      isAllowed = !!config.getAppointment()?.enable;
      break;
    case Product.COLLECT:
      isAllowed = !!config.getCollect()?.enabled;
      break;
    default:
      isAllowed = false;
  }

  if (!isAllowed) {
    return getDefaultRedirection();
  }

  appState.patch({ product: product });
  return true;
}


